export default __webpack_public_path__ + "static/media/9_16-story-mobile.138fd775.png";